export default __webpack_public_path__ + "9b4a8376323b576a6286079123974dc7.svg";